/* Vedicflora PLP infinite scroll — Dawn-aware.
 * Replaces numeric pagination with: scroll-triggered load AND a fallback button.
 * Dawn's "next page" link has class .pagination__item--prev (visually inverted),
 * so we disambiguate by reading data-page=N from .pagination-wrapper and finding
 * the link whose href has ?page=N+1.
 */
(function(){
  var loading = false;
  var done = false;
  var loadingIndicator = null;
  var loadMoreBtn = null;

  function findGrid(doc){
    var d = doc || document;
    return d.querySelector('ul#product-grid, ul.product-grid, product-grid, .product-grid-container ul');
  }
  function findWrap(doc){ return (doc || document).querySelector('.pagination-wrapper'); }
  function findNextLink(doc) {
    var wrap = findWrap(doc);
    if (!wrap) return null;
    var cur = parseInt(wrap.getAttribute('data-page') || '1', 10);
    var links = wrap.querySelectorAll('a');
    for (var i=0; i<links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var m = href.match(/[?&]page=(\d+)/);
      var p = m ? parseInt(m[1],10) : null;
      if (p && p === cur + 1) return links[i];
    }
    return null;
  }

  function showLoading(on) {
    if (!loadingIndicator) return;
    loadingIndicator.style.display = on ? 'block' : 'none';
    if (loadMoreBtn) loadMoreBtn.disabled = on;
  }

  function loadMore() {
    if (loading || done) return;
    var next = findNextLink();
    if (!next) { done = true; cleanup(); return; }
    loading = true;
    showLoading(true);
    fetch(next.href, { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = findGrid(doc);
        var existingGrid = findGrid();
        if (newGrid && existingGrid) {
          var children = Array.prototype.slice.call(newGrid.children);
          children.forEach(function(c){ existingGrid.appendChild(c); });
        }
        var newWrap = findWrap(doc);
        var existingWrap = findWrap();
        if (existingWrap && newWrap) {
          // Preserve our injected UI inside the wrap; only update data-page + links
          existingWrap.setAttribute('data-page', newWrap.getAttribute('data-page') || '');
          var nav = existingWrap.querySelector('nav');
          var newNav = newWrap.querySelector('nav');
          if (nav && newNav) nav.replaceWith(newNav);
        } else if (existingWrap && !newWrap) {
          done = true;
        }
        loading = false;
        showLoading(false);
        // Re-find next link from new state
        if (!findNextLink()) { done = true; if (loadMoreBtn) loadMoreBtn.style.display = 'none'; cleanup(); }
      })
      .catch(function(err){
        loading = false;
        showLoading(false);
        console && console.warn && console.warn('vf-inf: fetch failed', err);
      });
  }

  function injectUI() {
    var wrap = findWrap();
    if (!wrap) return;
    // Hide numeric pagination
    var nav = wrap.querySelector('nav');
    if (nav) nav.style.display = 'none';
    if (wrap.querySelector('.vf-inf-ui')) return;

    var box = document.createElement('div');
    box.className = 'vf-inf-ui';
    box.style.cssText = 'text-align:center;padding:24px 16px;';
    box.innerHTML =
      '<button class="vf-load-more" style="padding:14px 32px;border:1px solid currentColor;background:transparent;font-weight:600;border-radius:6px;cursor:pointer;">Load more products</button>'
    + '<div class="vf-loading" style="display:none;margin-top:12px;font-size:13px;opacity:0.7;">Loading…</div>';
    wrap.insertAdjacentElement('afterbegin', box);

    loadMoreBtn = box.querySelector('.vf-load-more');
    loadingIndicator = box.querySelector('.vf-loading');
    loadMoreBtn.addEventListener('click', loadMore);

    // Scroll-trigger: IntersectionObserver on the box
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) loadMore(); });
    }, { rootMargin: '600px 0px' });
    io.observe(box);
  }

  function cleanup() {
    var box = document.querySelector('.vf-inf-ui');
    if (box) box.remove();
  }

  function init() {
    if (!findGrid()) return;
    injectUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
